export function isUserBalancePositive(user) {
    return user?.allowedToWork && user?.billingStatus === "OK";
}